import React from "react";
import { Heading, Icon } from "@telia/teddy";
import { TextBlock } from "../../../../../../models";
import "./CampaignTextBlock.less";

interface CampaignTextBlockProps {
    textBlock: TextBlock;
}

const CampaignTextBlock: React.FC<CampaignTextBlockProps> = ({ textBlock }) => {
    // TODO(dark-mode): review, CMS-driven colors with fixed "white"/"black" fallbacks; suggested bg-card-primary and text-default once CMS color pairing is confirmed
    return (
        <div className="campaign-text-block" style={{ background: textBlock.contentBackgroundColor || "white" }}>
            {textBlock.headingIcon && (
                <Icon
                    className="campaign-text-block__icon"
                    name={textBlock.headingIcon}
                    style={{ color: textBlock.headingIconColor || "black" }}
                    aria-hidden="true"
                    focusable="false"
                />
            )}
            {textBlock.heading && (
                <Heading mb="100" variant="title-400" style={{ color: textBlock.headingTextColor || "black" }} as="h2">
                    {textBlock.heading}
                </Heading>
            )}
            {textBlock.content && (
                <span
                    className="campaign-text-block__content"
                    style={{ color: textBlock.contentTextColor || "black" }}
                    dangerouslySetInnerHTML={{ __html: textBlock.content }}
                />
            )}
        </div>
    );
};

export default CampaignTextBlock;
